// src/hooks/useDropdownAccessibility.js
// import { useRef, useEffect, useCallback } from "react";

// const useDropdownAccessibility = (isOpen, setOpen) => {
//   const triggerRef     = useRef(null);
//   const menuRef        = useRef(null);
//   const nextTriggerRef = useRef(null);

//   const setNext = useCallback((ref) => {
//     nextTriggerRef.current = ref?.current ?? ref;
//   }, []);

//   // ✅ Grabs both normal <a> links AND submenu parent titles
//   const getLinks = useCallback(() => {
//     return Array.from(
//       menuRef.current?.querySelectorAll(
//         [
//           "a[href]",
//           ".ant-dropdown-menu-submenu-title",
//         ].join(", ")
//       ) || []
//     );
//   }, []);

//   useEffect(() => {
//     if (!isOpen) return;

//     const onMenuKey = (e) => {
//       const links = getLinks();
//       if (!links.length) return;

//       const idx = links.indexOf(document.activeElement);

//       switch (e.key) {

//         case "Tab": {
//           if (e.shiftKey) {
//             if (idx === 0) {
//               e.preventDefault();
//               e.stopPropagation();
//               setOpen(false);
//               triggerRef.current?.focus();
//             }
//           } else {
//             if (idx === links.length - 1) {
//               // Last item → close, go to next nav trigger
//               e.preventDefault();
//               e.stopPropagation();
//               setOpen(false);
//               setTimeout(() => nextTriggerRef.current?.focus(), 30);
//             } else {
//               // Not last → stay in menu, move to next item
//               e.preventDefault();
//               e.stopPropagation();

//               const nextEl = links[idx + 1];

//               // ✅ If next is a submenu title, expand it then focus
//               const isSubmenuTitle = nextEl?.closest(
//                 ".ant-dropdown-menu-submenu-title"
//               );
//               if (isSubmenuTitle) {
//                 nextEl.click();
//                 setTimeout(() => nextEl.focus(), 50);
//               } else {
//                 nextEl?.focus();
//               }
//             }
//           }
//           break;
//         }

//         case "ArrowDown": {
//           e.preventDefault();
//           links[(idx + 1) % links.length]?.focus();
//           break;
//         }

//         case "ArrowUp": {
//           e.preventDefault();
//           links[(idx - 1 + links.length) % links.length]?.focus();
//           break;
//         }

//         case "Escape": {
//           e.preventDefault();
//           e.stopPropagation();
//           setOpen(false);
//           triggerRef.current?.focus();
//           break;
//         }

//         default:
//           break;
//       }
//     };

//     document.addEventListener("keydown", onMenuKey, true);
//     return () => document.removeEventListener("keydown", onMenuKey, true);
//   }, [isOpen, setOpen, getLinks]);

//   const focusItem = useCallback((position = "first") => {
//     setTimeout(() => {
//       const links = getLinks();
//       if (!links.length) return;
//       (position === "first"
//         ? links[0]
//         : links[links.length - 1]
//       )?.focus();
//     }, 60);
//   }, [getLinks]);

//   const onKeyDown = useCallback((e) => {
//     if (isOpen) return;

//     switch (e.key) {
//       case "Tab": {
//         if (!e.shiftKey) {
//           e.preventDefault();
//           setOpen(true);
//           focusItem("first");
//         }
//         break;
//       }
//       case "Enter":
//       case " ": {
//         e.preventDefault();
//         setOpen(true);
//         focusItem("first");
//         break;
//       }
//       case "ArrowDown": {
//         e.preventDefault();
//         setOpen(true);
//         focusItem("first");
//         break;
//       }
//       case "ArrowUp": {
//         e.preventDefault();
//         setOpen(true);
//         focusItem("last");
//         break;
//       }
//       case "Escape": {
//         e.preventDefault();
//         setOpen(false);
//         triggerRef.current?.focus();
//         break;
//       }
//       default:
//         break;
//     }
//   }, [isOpen, setOpen, focusItem]);

//   const popupRender = useCallback((menu) => (
//     <div ref={menuRef}>{menu}</div>
//   ), []);

//   return { triggerRef, onKeyDown, popupRender, setNext };
// };

// export default useDropdownAccessibility;


// src/hooks/useDropdownAccessibility.js
import { useRef, useEffect, useCallback } from "react";

const useDropdownAccessibility = (isOpen, setOpen) => {
  const triggerRef     = useRef(null);
  const menuRef        = useRef(null);
  const nextTriggerRef = useRef(null);

  const setNext = useCallback((ref) => {
    nextTriggerRef.current = ref?.current ?? ref;
  }, []);

  // ✅ Queries document directly — works even if submenu is in a portal
  const getLinks = useCallback(() => {
    if (!isOpen) return [];

    const links = [];

    // ── 1. Submenu parent titles inside main menu ──────────────
    menuRef.current
      ?.querySelectorAll(".ant-dropdown-menu-submenu-title")
      .forEach((el) => links.push(el));

    // ── 2. All <a href> inside main menu ───────────────────────
    menuRef.current
      ?.querySelectorAll("a[href]")
      .forEach((el) => links.push(el));

    // ── 3. All <a href> inside submenu portals (Ant Design      
    //       renders nested submenus outside menuRef in body) ────
    document
      .querySelectorAll(
        ".ant-dropdown-menu-submenu-popup:not(.ant-dropdown-menu-submenu-hidden) a[href]"
      )
      .forEach((el) => links.push(el));

    // Deduplicate and preserve order
    return [...new Set(links)];
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;



    const onMenuKey = (e) => {
      const links = getLinks();
      if (!links.length) return;

      const idx = links.indexOf(document.activeElement);

      switch (e.key) {

        case "Tab": {
          if (e.shiftKey) {
            if (idx === 0) {
              e.preventDefault();
              e.stopPropagation();
              setOpen(false);
              triggerRef.current?.focus();
            }
          } else {
            if (idx === links.length - 1) {
              e.preventDefault();
              e.stopPropagation();
              setOpen(false);
              setTimeout(() => nextTriggerRef.current?.focus(), 30);
            } else {
              e.preventDefault();
              e.stopPropagation();

              const nextEl = links[idx + 1];

              // ✅ If next element is submenu title → click to expand
              const isSubmenuTitle = nextEl?.classList?.contains(
                "ant-dropdown-menu-submenu-title"
              );
            //   if (isSubmenuTitle) {
            //     nextEl.click();
            //     setTimeout(() => nextEl.focus(), 100);
            //   } else {
            //     nextEl?.focus();
            //   }
                     if (isSubmenuTitle) {
                        nextEl.click();

                        setTimeout(() => {
                            // Find visible submenu links
                            const subMenuLinks = document.querySelectorAll(
                            ".ant-dropdown-menu-submenu-popup:not(.ant-dropdown-menu-submenu-hidden) a[href]"
                            );

                            if (subMenuLinks.length > 0) {
                            subMenuLinks[0].focus();
                            } else {
                            nextEl.focus();
                            }
                        }, 150);

                        } else {
                        nextEl?.focus();
}
            }
          }
          break;
        }

        case "ArrowDown": {
          e.preventDefault();
          links[(idx + 1) % links.length]?.focus();
          break;
        }

        case "ArrowUp": {
          e.preventDefault();
          links[(idx - 1 + links.length) % links.length]?.focus();
          break;
        }

        case "Escape": {
          e.preventDefault();
          e.stopPropagation();
          setOpen(false);
          triggerRef.current?.focus();
          break;
        }

        default:
          break;
      }
    };

    document.addEventListener("keydown", onMenuKey, true);
    return () => document.removeEventListener("keydown", onMenuKey, true);
  }, [isOpen, setOpen, getLinks]);

  const focusItem = useCallback((position = "first") => {
    setTimeout(() => {
      const links = getLinks();
      if (!links.length) return;
      (position === "first"
        ? links[0]
        : links[links.length - 1]
      )?.focus();
    }, 60);
  }, [getLinks]);

  const onKeyDown = useCallback((e) => {
    if (isOpen) return;

    switch (e.key) {
      case "Tab": {
        if (!e.shiftKey) {
          e.preventDefault();
          setOpen(true);
          focusItem("first");
        }
        break;
      }
      case "Enter":
      case " ": {
        e.preventDefault();
        setOpen(true);
        focusItem("first");
        break;
      }
      case "ArrowDown": {
        e.preventDefault();
        setOpen(true);
        focusItem("first");
        break;
      }
      case "ArrowUp": {
        e.preventDefault();
        setOpen(true);
        focusItem("last");
        break;
      }
      case "Escape": {
        e.preventDefault();
        setOpen(false);
        triggerRef.current?.focus();
        break;
      }
      default:
        break;
    }
  }, [isOpen, setOpen, focusItem]);

  const popupRender = useCallback((menu) => (
    <div ref={menuRef}>{menu}</div>
  ), []);

  return { triggerRef, onKeyDown, popupRender, setNext };
};

export default useDropdownAccessibility;